export default {
  getGeoBlockingRules: state => state.geoBlockingRules,
  getGeoBlockingRule: state => state.geoBlockingRule,
  getGeoBlockingRuleTypes: state => state.geoBlockingRuleTypes,
  getSelectedGeoBlockingRuleType: state => state.filters.params.geoBlockingRuleTypeId,
  getPagination: state => state.pagination,
  getPageLength: state => state.filters.params.take,
  getCurrentPage: state => state.filters.params.page,
}
